import { useAuthService } from '~domains/auth';

import LogoutIcon from '~shared/assets/icons/logout.svg?react';

import { Button } from '@breezeventures/ui-kit/button';

export const LogoutButton = () => {
  const { logout } = useAuthService();

  return (
    <Button type="button" variant="secondary" size="s" onClick={logout}>
      <Button.Icon>
        <LogoutIcon />
      </Button.Icon>
      Logout
    </Button>
  );
};
